(function () {
  function initCursorBlur(section) {
    if (!section || section.dataset.ewBlurInit === '1') return;
    section.dataset.ewBlurInit = '1';

    var mq = window.matchMedia('(hover: hover) and (pointer: fine)');
    if (!mq.matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var stacks = section.querySelectorAll('.everyday-words__text-stack');
    if (!stacks.length) return;

    var tx = -9999, ty = -9999, cx = -9999, cy = -9999;
    var running = false;
    var ease = 0.18;

    function paint() {
      for (var i = 0; i < stacks.length; i++) {
        var s = stacks[i];
        var r = s.getBoundingClientRect();
        s.style.setProperty('--ew-spot-x', (cx - r.left) + 'px');
        s.style.setProperty('--ew-spot-y', (cy - r.top) + 'px');
      }
    }

    function loop() {
      var dx = tx - cx;
      var dy = ty - cy;
      cx += dx * ease;
      cy += dy * ease;
      paint();
      if (Math.abs(dx) > 0.5 || Math.abs(dy) > 0.5) {
        requestAnimationFrame(loop);
      } else {
        cx = tx; cy = ty;
        paint();
        running = false;
      }
    }

    function start() {
      if (!running) { running = true; requestAnimationFrame(loop); }
    }

    section.addEventListener('pointerenter', function (e) {
      cx = tx = e.clientX;
      cy = ty = e.clientY;
      paint();
    });

    section.addEventListener('pointermove', function (e) {
      tx = e.clientX;
      ty = e.clientY;
      start();
    });

    section.addEventListener('pointerleave', function () {
      cx = tx = -9999;
      cy = ty = -9999;
      for (var i = 0; i < stacks.length; i++) {
        stacks[i].style.setProperty('--ew-spot-x', '-9999px');
        stacks[i].style.setProperty('--ew-spot-y', '-9999px');
      }
    });
  }

  function initAll() {
    var nodes = document.querySelectorAll('.everyday-words[data-cursor-blur="true"]');
    for (var i = 0; i < nodes.length; i++) initCursorBlur(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.everyday-words[data-cursor-blur="true"]');
    if (section) initCursorBlur(section);
  });
})();
